module.exports = __webpack_public_path__ + "static/media/image216.d5f682c5.png";